import React from 'react';
import { DotsStyles as S } from './Dots.styles';
const Dots = ({ activeIndex, itemCount }) => {
    return (React.createElement(S.Dots, null, Array.from(Array(itemCount)).map((_, index) => (React.createElement(S.Dot, { key: `dot-${index}`, "data-active": index == activeIndex })))));
};
export default Dots;
